export const environment = {
  production: false,
  apiBaseUrl: 'https://qa-scoca.casystem.com.mx/api/',
  entra: {
    // Debe coincidir con la variable de entorno ENTRA_ENABLED del backend en QA.
    enabled: true,
    clientId: '4806afa8-117d-4159-9f8c-f398f93a0a1e',
    tenantId: 'f374e576-15d5-44d5-96f6-9828c29f3160',
    scope: 'api://4806afa8-117d-4159-9f8c-f398f93a0a1e/access_as_user',
    redirectUri: 'https://qa-scoca.casystem.com.mx',
  },
};
